module.exports = __webpack_public_path__ + "9c6a210fff52a225613db785f38f11cc.svg";